import * as yup from 'yup';
import { get } from "lodash";

const validators = (__) => () => {
    return (
        yup.object({
            commercialName: yup.string().required(__(`form.commercialName.error`)),
            companyName: yup.string().required(__(`form.companyName.error`)),
            email: yup.string().email(__(`form.email.error2`)).required(__(`form.email.error`)),
            phone: yup.string().required(__(`form.phone.error`)),
            address: yup.string().required(__(`form.address.error`)),
            district: yup.string().required(__(`form.district.error`)),
            odooCode: yup.string().required(__(`form.odooCode.error`)),
            logPeriodicity: yup.string().required(__(`form.logPeriodicity.error`)),
        })
    )
}

export default validators
